import React, { useContext, useState } from "react";
import { GreenMachineContext } from "../GreenMachineContext";
import WarningBanner from "../../../../WarningBanner";
import ReportErrorOverlay from "../ReportErrorOverlay";
import { graphql, commitMutation } from "react-relay";
import relayEnvironment from "../../../../../RelayEnvironment";

const REPORT_ERROR = graphql`
  mutation GreenMachineErrorMutation(
    $greenMachineSessionID: ID!
    $error: String!
  ) {
    reportGreenMachineError(
      input: { greenMachineSessionId: $greenMachineSessionID, error: $error }
    ) {
      success
    }
  }
`;

export default function GreenMachineError() {
  const { errorMessage, greenMachineSessionID } = useContext(
    GreenMachineContext
  );

  const [reportedIssue, setReportedIssue] = useState(false);

  if (!errorMessage) {
    if (reportedIssue) {
      setReportedIssue(false);
    }

    return null;
  }

  function reportIssue(e) {
    e.preventDefault();

    commitMutation(relayEnvironment, {
      mutation: REPORT_ERROR,
      variables: {
        greenMachineSessionID: greenMachineSessionID,
        error: errorMessage,
      },
      onCompleted: (content, errors) => {
        setReportedIssue(true);
      },
    });
  }

  return (
    <>
      <WarningBanner active={true} style={{ padding: "10px" }}>
        {errorMessage}
        {!reportedIssue ? (
          <button onClick={reportIssue}>Report Issue</button>
        ) : (
          <span>Issue has been reported.</span>
        )}
      </WarningBanner>
      <br />
    </>
  );
}
